import '../../styles/style.css'
function TodoDay(){
    return(
        <h1 className='todo-day'>Wednesday</h1>
    )
}
export {TodoDay}